/**
 * 경량 방문 추적 유틸 (개인정보 보호: 익명 visitorId 만 사용, IP 미수집)
 * 추적 실패는 사용자 경험을 막지 않도록 조용히 무시한다.
 */

const API_BASE = process.env.REACT_APP_API_URL || '';
const VISITOR_ID_KEY = 'mansuk_visitor_id';

export type TrackPage =
  | 'landing'
  | 'signup'
  | 'signup_complete'
  | 'admin_demo'
  | 'kiosk_demo';

function getVisitorId(): string {
  try {
    let id = localStorage.getItem(VISITOR_ID_KEY);
    if (!id) {
      id =
        typeof crypto !== 'undefined' && crypto.randomUUID
          ? crypto.randomUUID()
          : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      localStorage.setItem(VISITOR_ID_KEY, id);
    }
    return id;
  } catch {
    // localStorage 차단 환경 — 휘발성 ID
    return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  }
}

export function track(page: TrackPage): void {
  try {
    const params = new URLSearchParams(window.location.search);
    const body: Record<string, string> = {
      visitorId: getVisitorId(),
      page,
      path: window.location.pathname + window.location.hash,
      referrer: document.referrer || '',
    };
    const utmSource = params.get('utm_source');
    const utmMedium = params.get('utm_medium');
    const utmCampaign = params.get('utm_campaign');
    if (utmSource) body.utmSource = utmSource;
    if (utmMedium) body.utmMedium = utmMedium;
    if (utmCampaign) body.utmCampaign = utmCampaign;

    fetch(`${API_BASE}/api/analytics/track`, {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).catch(() => {});
  } catch {
    // 무시
  }
}
